const local = window.localStorage;
const session = window.sessionStorage;

const action = callback => {
    try {
        if (typeof callback === 'function') return callback();
    } catch (err) {}
}

const listenToStorage = callback => {
    if (window.addEventListener) {
        window.addEventListener("storage", callback, false);
    } else {
        window.attachEvent("onstorage", callback);
    };
}

const handleVote = {
    set: (key, value) => action(() => local.setItem(key, value)),
    get: (key) => action(() => (local.getItem(key) === "true"))
}

const handleSelected = {
    set: (key, value) => action(() => session.setItem(key, value)),
    get: (key) => action(() => session.getItem(key))
}

export {
    handleVote,
    handleSelected
}


// WEBPACK FOOTER //
// ./src/Components/Services/Storage.js